import { FETCH_PROGRAMS, FETCH_PROGRAM_INFO, RESET_PROGRAMS, FETCH_INDIVIDUAL_PROGRAM_WORKOUTS, UPDATE_ORDER_PROGRAMS } from '../actionTypes';

const initialState = {
  data: {},
  isLoadMore: false,
  info: {},
  workouts: []
};

export default function(state = initialState, action=null){
  switch (action.type) {
    case FETCH_PROGRAMS:
      let isLoadMore = true;
      if (Object.keys(action.payload).length < 10) {
        isLoadMore = false;
      }
      return {
        ...state,
        data: {...state.data, ...action.payload},
        isLoadMore: isLoadMore
      }
    case UPDATE_ORDER_PROGRAMS:
        const items = action.payload;
        let obj = {};
        for(let i = 0; i < items.length; i++) {
           const d = items[i];
           obj[d._id] = d;
        }
        return {
          ...state,
          data: obj
        }
    case FETCH_PROGRAM_INFO:
      return {
        ...state,
        info: action.payload
      }
    case FETCH_INDIVIDUAL_PROGRAM_WORKOUTS:
      return {
        ...state,
        workouts: { ...action.payload}
      }
    case RESET_PROGRAMS:
        return initialState
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/programs.js